import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { TramiteAbreviacion } from '../models/TramiteAbreviacion';

@Injectable({
  providedIn: 'root'
})
export class TramiteAbreviacionesService {

  private LIST_TRAMITE_ABREVIACIONES_URL = environment.apiUrl + "abreviatura/list"
  private POST_TRAMITE_ABREVIACION_URL = environment.apiUrl + "abreviatura"
  private PATCH_TRAMITE_ABREVIACION_URL = environment.apiUrl + "abreviatura/"
  private DELETE_TRAMITE_ABREVIACION_URL = environment.apiUrl + "abreviatura/"

  constructor(
    private httpClient: HttpClient
  ) { }

  listTramiteAbreviaciones(): Observable<TramiteAbreviacion[]> {
    return this.httpClient.get<TramiteAbreviacion[]>(this.LIST_TRAMITE_ABREVIACIONES_URL)
  }

  postTramiteAbreviacion(abreviacion: TramiteAbreviacion): Observable<TramiteAbreviacion> {
    return this.httpClient.post<TramiteAbreviacion>(this.POST_TRAMITE_ABREVIACION_URL, abreviacion)
  }

  patchTramiteAbreviacion(abreviacion: TramiteAbreviacion): Observable<TramiteAbreviacion> {
    return this.httpClient.patch<TramiteAbreviacion>(this.PATCH_TRAMITE_ABREVIACION_URL + abreviacion.id, abreviacion)
  }

  deleteTramiteAbreviacion(id: number): Observable<string> {
    return this.httpClient.delete(this.DELETE_TRAMITE_ABREVIACION_URL + id.toString(), {
      responseType: "text",
    })
  }
}
